document.addEventListener('DOMContentLoaded', () => {

    // shows plans event..
    const featuresGroupToggles = window.innerWidth <= 991 ? document.querySelectorAll('.grootapps_plan-fg-head-wrap.feature-group-row') : document.querySelectorAll('.feature-group-row');
  
    if (featuresGroupToggles.length > 0) {
      
      // open first row on load..
      const firstToggle = featuresGroupToggles[0];
      const firstGroupId = firstToggle.getAttribute('data-group-id');
      const firstRows = document.querySelectorAll(`.plans_featuers-options-tr[data-group-id="${firstGroupId}"]`);
      const firstIconTd = firstToggle.querySelector('.feature-group-icon-td');
      const firstNextSibling = firstToggle.nextElementSibling;

      if (window.innerWidth <= 991) {
          firstToggle.classList.toggle('active');

          if (firstNextSibling) {
              firstNextSibling.style.maxHeight = firstNextSibling.scrollHeight + 'px';
          }
      }else{
        firstRows.forEach(row => {
            row.classList.remove('hidden');
            firstToggle.classList.add('active');
        });
      }
      if (firstIconTd) {
          const img = firstIconTd.querySelector('img');
          const minusIcon = firstIconTd.getAttribute('data-minus');
          if (img && minusIcon) {
              img.src = minusIcon;
          }
      }

      featuresGroupToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
          const groupId = toggle.getAttribute('data-group-id');
          const rows = document.querySelectorAll(`.plans_featuers-options-tr[data-group-id="${groupId}"]`);
          const nextSibling = toggle.nextElementSibling;

          let isOpen = toggle.classList.contains('active');

          toggle.classList.toggle('active');
          isOpen = !isOpen;
      
          if (window.innerWidth <= 991) {
              if (nextSibling) {
                  if (isOpen) {
                      nextSibling.style.maxHeight = nextSibling.scrollHeight + 'px';
                  } else {
                      nextSibling.style.maxHeight = '0px';
                  }
              }
          }else{
            rows.forEach(row => {
                row.classList.toggle('hidden', !isOpen);
            });
          }
          
          // icon update...
          const iconTd = toggle.querySelector('.feature-group-icon-td');
          if (iconTd) {
            const img = iconTd.querySelector('img');
            const plusIcon = iconTd.getAttribute('data-plus');
            const minusIcon = iconTd.getAttribute('data-minus');
  
            if (isOpen) {
              img.src = minusIcon;
            } else {
              img.src = plusIcon;
            }
          }
        });
      });
    }


    // checkbox event...
    const checkboxToggle = document.getElementById('grootapps_pricing_switch');

    const planHeaders = document.querySelectorAll('.plan-header');
  
    function updatePlans() {
      const isYearly = checkboxToggle.checked;
      const monthlyPlan = document.querySelector('.grootapps_monthly-plan');
      const yearlyPlan = document.querySelector('.grootapps_yearly-plan');
  
      planHeaders.forEach(header => {
        const planId = header.getAttribute('data-plan-id');
        if (isYearly && planId.includes('yearly')) {
            header.classList.remove('hidden');
            yearlyPlan.classList.add('active');
            monthlyPlan.classList.remove('active');

            document.querySelectorAll(`.plans_featuers-first-option-td[data-plan-id="${planId}"]`).forEach(cell => {
                cell.classList.remove('hidden');
            });
        } else if (!isYearly && planId.includes('monthly')) {
            header.classList.remove('hidden');
            yearlyPlan.classList.remove('active');
            monthlyPlan.classList.add('active');

            document.querySelectorAll(`.plans_featuers-first-option-td[data-plan-id="${planId}"]`).forEach(cell => {
                cell.classList.remove('hidden');
            });
        } else {
            header.classList.add('hidden');

            document.querySelectorAll(`.plans_featuers-first-option-td[data-plan-id="${planId}"]`).forEach(cell => {
                cell.classList.add('hidden');
            });
        }
      });
    }
  
    checkboxToggle.addEventListener('change', updatePlans);
  
    updatePlans();

  });
  